var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header-info',{attrs:{"navInfoItems":_vm.schema.navInfoItems}}),_c('pro-login',{attrs:{"schemaForm":_vm.schema.schemaForm,"modelForm":_vm.model,"save":_vm.handleLogin,"status":_vm.status}}),_c('v-snack-bar',{attrs:{"snackbar":_vm.snackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }